import AppStoreModal from "./AppStoreModal";
import useAppStoreModal from "./use-app-store-modal";

export default AppStoreModal;

export {
  useAppStoreModal,
};
